<div class="content p-24">
  <div class="example-viewer-wrapper mat-white-bg mat-elevation-z2">

    <mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="this.selectedIndex">
        <mat-tab label="Gegevens"> 
            <div class="example-viewer-body">
              <div class="example-container">
                <fieldset>
                  <legend>Gegevens Medewerker:</legend>
                  <div>
                      <p>Afdeling:</p>
                      <p-multiSelect [options]="afdelingen" [(ngModel)]="selectedAfdelingen" (onChange)="onAfdelingChange()" [style]="{'width':'230px'}"></p-multiSelect >
                     
                  </div>
                  <div>
                      <p>Medewerker:</p>
                      <p-dropdown [options]="medewerkers" [(ngModel)]="selectedMedewerker" (onChange)="onMedewerkerChange()" [style]="{'width':'230px'}" [filter]="true" ></p-dropdown >
                  </div>
                  <div>
             <mat-form-field>
                      <input matInput  [matDatepicker]="weekdatum" placeholder="Weekdatum" (dateChange)="onWeekDatumChange($event)" [(ngModel)]="selectedWeekDatum">
                      <mat-datepicker-toggle matSuffix [for]="weekdatum"></mat-datepicker-toggle>
                      <mat-datepicker #weekdatum ></mat-datepicker>
                  </mat-form-field> 
                </div>
                <div>
                  <p>Week: {{WeekNr}}</p>
              </div>
                </fieldset>   

                <fieldset>
                  <p>Let op: Indien er spareparts besteld worden doe dat dan eerst en dan dit pas! Je kan spareparts bestellen via <a href = "https://bakeryspareparts.nl">deze link</a> daaruit krijg je een projectnummer die je hier invult. Indien je nog geen projectnummer weet laat dit dan leeg dan word het automatisch aangemaakt.</p>
                  <legend>Gegevens Project:</legend>
                  <div>
                      <mat-form-field>
                        <input [(ngModel)]="projectNumber"  (blur)="onLeaveProjectNumber()" matInput placeholder="Bestaand Project">   
                      </mat-form-field>     
                  </div>
                  <div>
                    <mat-checkbox  (change)="onKlantUitPlanningChange($event)" [(ngModel)]="cbBestaandPlanning">Gegevens uit de planning</mat-checkbox>
                    <p>Bedrijf:</p>
                    <p-dropdown [disabled]="disableCbBedrijf" [filter]="true" (onChange)="onCompanyChange()" [options]="bedrijven" [style]="{'width':'230px'}" [(ngModel)]="selectedBedrijf"></p-dropdown >
                     <!--  <p-dropdown [disabled]="disableCbContact" [filter]="true" [options]="contactpersonen" [style]="{'width':'230px'}" [(ngModel)]="selectedContact"></p-dropdown > -->
                   <div *ngIf="cbBestaandPlanning" >
                      <p>Planning Onderwerp:</p>
                    <p-dropdown [filter]="true" [options]="planningOnderwerpen" [style]="{'width':'230px'}" [(ngModel)]="selectedPlanningOnderwerp"></p-dropdown >
                    </div>
                </div>
                  <div>
                    <mat-form-field>
                        <textarea [(ngModel)]="Omschrijving" matInput style = "height:125px;resize: none;" placeholder="Omschrijving:"></textarea>
                    </mat-form-field>
                </div>
                </fieldset>

              </div>
              <p *ngIf="!Status">
                  {{Error}}
              </p>    
            <div class = "opslaanclass" fxLayout="row">
                  <button (click)="volgendeTab()" style = "margin-left:20px;" mat-raised-button color="accent">Volgende</button>
            </div>
          </div>

        </mat-tab>
        <mat-tab *ngFor = "let n of this.weekDagenLijst" [disabled]='!tab2' label={{n.Dag}}>
            <div class="example-viewer-body">
                <div class="example-container">
                  <h2>Week: {{WeekNr}}</h2>
                  <fieldset>
                      <legend>{{currentWeekDay}}</legend>
                      <div>
                          <p>Storing: <mat-checkbox [(ngModel)]="n.Storing"></mat-checkbox> </p>
                      </div>
                      <div>
                          <p>Vertrek: <p-calendar [(ngModel)]="n.Vertrek" [timeOnly]="true" [stepMinute]=5 [defaultDate]="defaultDate" ></p-calendar></p>
                      </div>
                      <div>
                          <p>Aankomst: <p-calendar [(ngModel)]="n.Aankomst" [timeOnly]="true" [stepMinute]=5 [defaultDate]="defaultDate"></p-calendar></p>
                      </div>
                      <div>
                          <p>Pauze: <p-calendar [(ngModel)]="n.Pauze" [timeOnly]="true" [stepMinute]=5 [defaultDate]="defaultPauzeDate"></p-calendar></p>
                      </div>
                      <div>
                          <p>Terug: <p-calendar [(ngModel)]="n.Terug" [timeOnly]="true" [stepMinute]=5 [defaultDate]="defaultDate"></p-calendar></p>
                      </div>
                      <div>
                          <p>Thuis: <p-calendar [(ngModel)]="n.Thuis" [timeOnly]="true" [stepMinute]=5 [defaultDate]="defaultDate"></p-calendar></p>
                      </div>
                      <div>
                          <mat-form-field>
                          <input matInput appTwoDigitDecimaNumber [(ngModel)]="n.Kilometers" placeholder="Kilometers">
                        </mat-form-field>
                      </div>
                      <div>
                          <mat-form-field class="example-full-width">
                              <textarea matInput [(ngModel)]="n.Bijzonderheden" placeholder="Bijzonderheden:"></textarea>
                          </mat-form-field>
                      </div>
                  </fieldset>
                </div>
                <p *ngIf="!Status">
                    {{Error}}
                </p>    
                <div class = "opslaanclass" fxLayout="row">
                    <button (click)="terugTab()" mat-raised-button>Terug</button>
                    <button (click)="volgendeTab()" style = "margin-left:20px;" mat-raised-button color="accent">Volgende</button>
              </div>
                
            </div>

        </mat-tab>
        <mat-tab [disabled]='!tab3' label="Opmerkingen"> 
            <div class="example-viewer-body">
              <div class="example-container">
                <fieldset>
                  <legend>Divardy Informatie</legend>
                  <div>
                    <mat-form-field style="width:300px;" class="example-full-width">
                        <textarea [(ngModel)]="werkOmschrijving" matInput placeholder="Werkomschrijving:"></textarea>
                    </mat-form-field>
                  </div>
                  <div>
                    <mat-form-field style="width:300px;" class="example-full-width">
                        <textarea [(ngModel)]="geleverdeMaterialen" matInput placeholder="Geleverde materialen:"></textarea>
                    </mat-form-field>
                  </div>
                <!--   <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad> -->
                  <canvas #sPad width="300" height="300" style="touch-action: none;"></canvas>
                  <div fxLayout="row">
                    <button (click)="drawClear()" mat-raised-button>Clear signature</button>
                  </div>
                  <p *ngIf="!Status">
                      {{Error}}
                  </p>    
                  <div class = "opslaanclass" fxLayout="row">
                    <button (click)="terugTab()" mat-raised-button>Terug</button>
                    <button [disabled] = "disableBtnBewaar" (click)="onBewaarWerkBon()" style = "margin-left:20px;" mat-raised-button color="accent">Bewaren</button>
                    <button (click)="onOpslaanWerkBon()" style = "margin-left:20px;" mat-raised-button color="accent">Opslaan</button>
                  </div>
                </fieldset>
            </div>         
          </div>
        </mat-tab>
    </mat-tab-group>
  
  </div>


</div>